// src/achievements.js

export const achievements = [
  // Combat Achievements
  {
    id: 1,
    name: "Novice Slayer",
    description: "Defeat 10 enemies.",
    category: "Combat",
    type: "incremental",
    target: "kills",
    targetValue: 10,
    reward: { type: "gold", value: 50 },
  },
  {
    id: 2,
    name: "Undead Hunter",
    description: "Defeat 15 Undead enemies.",
    category: "Combat",
    type: "incremental",
    target: "killsByType",
    targetSubType: "Undead",
    targetValue: 15,
    reward: { type: "ectoplasm", value: 20 },
  },
  {
    id: 3,
    name: "Rare Trophy",
    description: "Defeat a Rare enemy.",
    category: "Combat",
    type: "milestone",
    target: "killsByRarity",
    targetSubType: "Rare",
    targetValue: 1,
    reward: { type: "item", value: "Rare Token", hp: 10, type: "Consumable" },
  },
  {
    id: 4,
    name: "Skeleton Smasher",
    description: "Defeat 5 Skeletons in the Shattered Vestibule.",
    category: "Combat",
    type: "incremental",
    target: "killsByName",
    targetSubType: "Skeleton",
    zoneId: 1,
    targetValue: 5,
    reward: { type: "gold", value: 30 },
  },

  // Exploration Achievements
  {
    id: 5,
    name: "Crypt Explorer",
    description: "Clear 5 floors in any Crypt zone.",
    category: "Exploration",
    type: "incremental",
    target: "floorsCleared",
    zoneRegion: "Crypt",
    targetValue: 5,
    reward: { type: "gold", value: 100 },
  },
  {
    id: 6,
    name: "Wasteland Wanderer",
    description: "Visit the Cursed Expanse Wastes.",
    category: "Exploration",
    type: "milestone",
    target: "zoneVisited",
    zoneRegion: "Cursed Expanse Wastes",
    targetValue: 1,
    reward: { type: "ectoplasm", value: 30 },
  },
  {
    id: 7,
    name: "Deep Diver",
    description: "Clear 10 floors across all zones.",
    category: "Exploration",
    type: "incremental",
    target: "floorsCleared",
    targetValue: 10,
    reward: { type: "gold", value: 150 },
  },

  // Quest Achievements
  {
    id: 8,
    name: "Quest Initiate",
    description: "Complete 3 quests.",
    category: "Quests",
    type: "incremental",
    target: "questsCompleted",
    targetValue: 3,
    reward: { type: "gold", value: 80 },
  },
  {
    id: 9,
    name: "Hero of the Crypt",
    description: "Complete a quest in the Shattered Vestibule.",
    category: "Quests",
    type: "milestone",
    target: "questsCompletedInZone",
    zoneId: 1,
    targetValue: 1,
    reward: { type: "item", value: "Crypt Key", type: "Key" },
  },

  // Wealth Achievements
  {
    id: 10,
    name: "Gold Hoarder",
    description: "Collect 500 gold.",
    category: "Wealth",
    type: "incremental",
    target: "gold",
    targetValue: 500,
    reward: { type: "ectoplasm", value: 50 },
  },
  {
    id: 11,
    name: "Ectoplasm Collector",
    description: "Collect 200 ectoplasm.",
    category: "Wealth",
    type: "incremental",
    target: "ectoplasm",
    targetValue: 200,
    reward: { type: "gold", value: 100 },
  },

  // Progression Achievements
  {
    id: 12,
    name: "Rising Star",
    description: "Reach level 5.",
    category: "Progression",
    type: "milestone",
    target: "level",
    targetValue: 5,
    reward: { type: "gold", value: 200 },
  },
  {
    id: 13,
    name: "Veteran Adventurer",
    description: "Reach level 10.",
    category: "Progression",
    type: "milestone",
    target: "level",
    targetValue: 10,
    reward: { type: "item", value: "Veteran Badge", type: "Accessory", def: 2 },
  },

  // Interaction Achievements
  {
    id: 14,
    name: "Trader",
    description: "Trade with an NPC 3 times.",
    category: "Interaction",
    type: "incremental",
    target: "npcTrades",
    targetValue: 3,
    reward: { type: "gold", value: 50 },
  },
  {
    id: 15,
    name: "Item Master",
    description: "Use or equip 5 items.",
    category: "Interaction",
    type: "incremental",
    target: "itemsUsedOrEquipped",
    targetValue: 5,
    reward: { type: "ectoplasm", value: 30 },
  },

  // Waypoint Achievements
  {
    id: 16,
    name: "Waypoint Novice",
    description: "Unlock 3 waypoints.",
    category: "Waypoints",
    type: "incremental",
    target: "waypointsUnlocked",
    targetValue: 3,
    reward: { type: "gold", value: 50 },
  },
  {
    id: 17,
    name: "Waypoint Explorer",
    description: "Unlock 8 waypoints.",
    category: "Waypoints",
    type: "incremental",
    target: "waypointsUnlocked",
    targetValue: 8,
    reward: { type: "ectoplasm", value: 50 },
  },
  {
    id: 18,
    name: "Waypoint Master",
    description: "Unlock all waypoints.",
    category: "Waypoints",
    type: "incremental",
    target: "waypointsUnlocked",
    targetValue: 14, // Total number of waypoints
    reward: { type: "item", value: "Waypoint Compass", type: "Accessory", def: 3 },
  },
  {
    id: 19,
    name: "Frequent Traveler",
    description: "Travel using waypoints 5 times.",
    category: "Waypoints",
    type: "incremental",
    target: "waypointTravels",
    targetValue: 5,
    reward: { type: "gold", value: 100 },
  },
  {
    id: 20,
    name: "Shattered Wayfarer",
    description: "Unlock the King’s Chamber Waypoint in the Shattered Vestibule.",
    category: "Waypoints",
    type: "milestone",
    target: "waypointUnlocked",
    waypointId: 4, // King’s Chamber Waypoint
    targetValue: 1,
    reward: { type: "ectoplasm", value: 30 },
  },
  {
    id: 21,
    name: "Veil Nexus Pioneer",
    description: "Unlock the Veil Nexus Core Waypoint.",
    category: "Waypoints",
    type: "milestone",
    target: "waypointUnlocked",
    waypointId: 11, // Veil Nexus Core Waypoint
    targetValue: 1,
    reward: { type: "item", value: "Veil Shard", type: "Consumable", hp: 20 },
  },
  {
    id: 22,
    name: "Oasis Seeker",
    description: "Unlock the Sacred Spring Waypoint in the Oasis of the Lost.",
    category: "Waypoints",
    type: "milestone",
    target: "waypointUnlocked",
    waypointId: 12, // Sacred Spring Waypoint
    targetValue: 1,
    reward: { type: "gold", value: 80 },
  },
];

// Helper function to get achievements by category
export function getAchievementsByCategory(category) {
  return achievements.filter((achievement) => achievement.category === category);
}

// Helper function to get achievements by target
export function getAchievementsByTarget(target) {
  return achievements.filter((achievement) => achievement.target === target);
}

// Helper function to get an achievement by ID
export function getAchievementById(achievementId) {
  return achievements.find((achievement) => achievement.id === achievementId);
}

// Helper function to get achievements by zone (if zone-specific)
export function getAchievementsByZone(zoneId) {
  return achievements.filter((achievement) => achievement.zoneId === zoneId);
}

// Helper function to get achievements by zone region (e.g., "Crypt", "Cursed Expanse Wastes")
export function getAchievementsByZoneRegion(zoneRegion) {
  return achievements.filter((achievement) => achievement.zoneRegion === zoneRegion);
}

// Helper function to get achievements by waypoint (if waypoint-specific)
export function getAchievementsByWaypoint(waypointId) {
  return achievements.filter((achievement) => achievement.waypointId === waypointId);
}